export class StyleTools {
    static removeLayers(style, layerIds) {
        const origLayers = style.layers;
        for (const id of layerIds) {
            const index = origLayers.findIndex(l => l.id === id);
            if (index < 0) {
                continue; // already removed
            }
            origLayers.splice(index, 1);
        }
    }
    static addLayer(style, layer, beforeLayer) {
        const i = style.layers.findIndex(x => x.id == beforeLayer);
        if (i == -1) {
            style.layers.push(layer);
        }
        else {
            style.layers.splice(i, 0, layer);
        }
    }
    static IsOnewayFilter() {
        return ["any",
            ["==", "anyways:oneway", 1],
            ["all",
                ["!has", "anyways:oneway"],
                ["==", "oneway", 1]
            ]
        ];
    }
    static IsOnewayReverseFilter() {
        return ["any",
            ["==", "anyways:oneway", -1],
            ["all",
                ["!has", "anyways:oneway"],
                ["==", "oneway", -1]
            ]
        ];
    }
}
